import { Row, Col } from 'antd';
import styled from 'styled-components';

export const colors = {
  'clear-blue': '#2b9bff',
  'cloudy-blue': '#bbc3d3'
}

export const Header = styled(Row)`
  border-bottom: 4px solid ${colors['clear-blue']};
  background-color: white;
`

export const StyledCol = styled(Col)`
`

export const HeaderBlockContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 20px 0 10px;
  margin: 15px 0;
  align-items: center;
  min-height: 80px;

  /* Allow left content to shrink/wrap inside this flex row (prevents long strings expanding the header) */
  > span {
    flex: 1 1 auto;
    min-width: 0;
  }

  /* Wrap long tokens (e.g. emails) instead of overflowing/pushing the container */
  > span p {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  /* Customer name row is flex; allow it to wrap when it needs to */
  > span .title_customer-name {
    flex-wrap: wrap;
    min-width: 0;
  }

  &:not(.no-border) {
    border-right: 1px solid ${colors['cloudy-blue']};
  }

  .payment-method {
    margin-top: 8px;
  }
`
